import { queryKeyStore } from '@bupa-monorepo/shared-frontend/query-key-store';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { lawyerOfferNeeded } from '../../api/single-person/lawyer-offer-needed';

export const useLawyerOfferNeeded = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (lawyerId: string) => lawyerOfferNeeded(lawyerId),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: queryKeyStore.companyCreation.companyCreations.queryKey,
      });
    },
  });
};
